<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7605 17.3029L6.32422 12.1494L11.7605 6.99968" stroke="#161717" stroke-width="1.5" stroke-miterlimit="10"/>
<path d="M6.42791 12.1494L18 12.1494" stroke="#161717" stroke-width="1.5" stroke-miterlimit="10"/>
</svg>
